module.exports = __webpack_public_path__ + "static/media/undraw_image_focus_wm20.aee377b6.svg";